import React, { useRef, useState } from "react"

import useTracking from "hooks/useTracking"

import Icon from "icons"
import List from "./list"
import SelectedCategories from "./selected-categories"
import {
  Wrapper,
  TopContainer,
  Left,
  Title,
  Image,
  ViewButton,
  Right,
  Description,
  ButtonContainer,
  TextAndCodeContainer,
  DiscountAndIconContainer,
  ReadMoreButton,
} from "./styles"

const Item = ({
  idx,
  sources = [],
  productId,
  title,
  category,
  company,
  image,
  list,
  selectedCategories,
  description,
  articleId,
}) => {
  const { trackView, trackClick } = useTracking()
  const viewRef = useRef(null)
  const clickRef = useRef(null)
  const [showAllDescription, setShowAllDescription] = useState(false)
  const paragraphs = description?.split("</p>").filter(Boolean)
  const source = sources.length ? sources[0].source : ""
  const trackingId = `Review Component | ${title} | ${source}`
  const trackingProps = {
    label: trackingId,
    category: "Commerce Engagement",
    product: title,
    product_id: productId,
    quickView: false,
    source,
  }

  trackView(viewRef, trackingId, trackingProps)
  trackClick(clickRef, trackingId, trackingProps)

  const actualDate = new Date().toISOString()

  return (
    <Wrapper id={`review-item-${idx}`} ref={viewRef}>
      <TopContainer>
        <Left>
          <Title>
            {category ? `${category}:` : ""} {company} {title}
          </Title>
          {image && image.path && (
            <Image
              baseUrl={image.path}
              images={[
                {
                  screenSize: 1024,
                  transforms: "c_fit,w_380,h_260,q_auto,fl_lossy,f_auto",
                },
                {
                  screenSize: 768,
                  transforms: "c_fit,w_670,h_460,q_auto,fl_lossy,f_auto",
                },
                {
                  screenSize: 425,
                  transforms: "c_fit,w_370,h_255,q_auto,fl_lossy,f_auto",
                },
                {
                  transforms: "c_fit,w_370,h_255,q_auto,fl_lossy,f_auto",
                },
              ]}
              contain
              lazy
            />
          )}

          {sources.map((button) => {
            const { promotion } = button
            const dateCheck =
              promotion?.endsAt || promotion?.startsAt
                ? promotion?.startsAt < actualDate || promotion?.endsAt > actualDate
                : true
            const url =
              promotion?.url && promotion?.isActive && dateCheck ? promotion?.url : button.url

            const price = button.price
              ? Number.isNaN(parseInt(button.price))
                ? ` | ${button.price}`
                : ` | $${button.price}`
              : ""

            return (
              <ButtonContainer
                key={`review-button-${button.id}`}
                isActive={promotion?.isActive && dateCheck}
              >
                <TextAndCodeContainer isActive={promotion?.isActive && dateCheck}>
                  {promotion?.text}:
                  <DiscountAndIconContainer>
                    <Icon width={30} height={19} id="promo-icon" />
                    {promotion?.code}
                  </DiscountAndIconContainer>
                </TextAndCodeContainer>
                <ViewButton ref={clickRef} href={url} target="_blank" rel="sponsored">
                  view on {button.source}
                  {price}
                </ViewButton>
              </ButtonContainer>
            )
          })}
        </Left>
        <Right>
          {list && list.map((item) => <List key={`review-list-${item.id}`} {...item} />)}
          {selectedCategories &&
            selectedCategories.map((item, i) => (
              <SelectedCategories key={`review-selected-categories-${item.id}`} {...item} idx={i} />
            ))}
        </Right>
      </TopContainer>
      <div className="exp-review-standard">
        <Description dangerouslySetInnerHTML={{ __html: description }} />
      </div>

      <div className="exp-review-toggle" style={{ display: "none" }}>
        {showAllDescription ? (
          <Description dangerouslySetInnerHTML={{ __html: description }} />
        ) : (
          <Description dangerouslySetInnerHTML={{ __html: paragraphs ? paragraphs[0] : "" }} />
        )}
        {paragraphs?.length > 1 && (
          <ReadMoreButton
            aria-expanded={showAllDescription}
            onClick={() => setShowAllDescription(!showAllDescription)}
          >
            {showAllDescription ? "Read less" : "Read full review"}
          </ReadMoreButton>
        )}
      </div>
    </Wrapper>
  )
}

export default Item
